﻿// Address
export const CHANGE_ADDRESS_QUERY = 'CHANGE_ADDRESS_QUERY';
export const RESET_ADDRESS_SUGGESTIONS = 'RESET_ADDRESS_SUGGESTIONS';
export const ADDRESS_LOOKUP_FAILURE = 'ADDRESS_LOOKUP_FAILURE';
export const ADDRESS_LOOKUP_SUCCESS = 'ADDRESS_LOOKUP_SUCCESS';
export const STORE_SELECTED_ADDRESS = 'STORE_SELECTED_ADDRESS';
export const RESET_SELECTED_ADDRESS = 'RESET_SELECTED_ADDRESS';
export const SET_ADDRESS_QUERY = 'SET_ADDRESS_QUERY';
export const RESET_ADDRESS_LOOKUP = 'RESET_ADDRESS_LOOKUP';


// Products
export const BEGIN_PRODUCT_SEARCH = 'BEGIN_PRODUCT_SEARCH';
export const STORE_AVAILABLE_PRODUCTS = 'STORE_AVAILABLE_PRODUCTS';
export const SELECT_VARIANT = 'SELECT_VARIANT';
export const SET_BLOCK_ID = 'SET_BLOCK_ID';

// VAS
export const SELECT_VAS = 'SELECT_VAS';
export const DESELECT_VAS = 'DESELECT_VAS';
export const SELECTED_VAS = 'SELECTED_VAS';
export const SHOW_VAS_SELECTION_MODAL = 'SHOW_VAS_SELECTION_MODAL';
export const UPDATE_CART_PRICE = 'UPDATE_CART_PRICE';
export const SET_MAX_NUMBER_OF_VAS = 'SET_MAX_NUMBER_OF_VAS';
export const SHOW_VAS_LIMIT_MODAL = 'SHOW_VAS_LIMIT_MODAL';

export const SHOW_ADDRESS_MISSING_MODAL = 'SHOW_ADDRESS_MISSING_MODAL';